import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppV2 from './v2/App';
import reportWebVitals from './reportWebVitals';
import StringQuery from 'stringquery';

const useV2 = StringQuery(window.location.search)['ver'] === '2';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {useV2 ? <AppV2 /> : <AppV2 />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
